import React from "react";
import {
  Dialog,
  DialogTitle,
  IconButton,
  WithStyles,
  withStyles,
} from "@material-ui/core";
import { Close } from "@material-ui/icons";
import ExportEvents from '@components/calendar-export/export.calendar';
import { externalCalendarStyles } from "./externalCalender.style";
import { IExternalCalendar } from "@app-types/websocket/externalCalender.types";
import TranslateNew from "@translate/TranslateNew";
import { DialogTop } from "@components/economy/DialogComponens";

const tn: TranslateNew = TranslateNew.getInstance();

interface IProps extends WithStyles<typeof externalCalendarStyles> {
  open: boolean;
  close: () => void;
}

class ExportCalendarDialog extends React.Component<IProps> {
  constructor(props: IProps) {
    super(props);
  }

  public render() {
    const { classes, open, close } = this.props;

    return (
      <>
        <Dialog open={open} onClose={close} fullWidth={true} maxWidth="sm">
          <DialogTop>
            <DialogTitle>{""}</DialogTitle>
            <IconButton onClick={close}>
              <Close />
            </IconButton>
          </DialogTop>


          <div className={classes.importedActions}>
            <ExportEvents />
          </div>
        </Dialog>
      </>
    );
  }
}  



export default withStyles(externalCalendarStyles)(ExportCalendarDialog);


// WEBPACK FOOTER //
// ./src/components/calendar2/externalCalendar/ExportCalendarDialog.tsx